import type React from "react";

import styled from "styled-components";

import { ListItemWebsite, ListItemSegment as segmentListItem } from "@similarweb/ui-components";

import type { ICustomSegment } from "app/services/segments/segmentsApiService";
import { SEGMENT_TYPES } from "app/services/segments/segmentsApiService";
const SHARE_ICON = "share-new";

const SegmentListItemWrapper = styled(segmentListItem)`
    &.SegmentsListItemDisabled {
        cursor: not-allowed !important;
        opacity: 0.4;
    }
`;

const DomainListItemWrapper = styled(ListItemWebsite)``;

export interface IListItemSegment {
    onClick?: () => void;
    isActive?: boolean;
    className?: string;
    img: string;
    domain: string;
    name: string;
    itemSignType?: SEGMENT_TYPES;
    onActionClick?: (segment: ICustomSegment, isOpen: boolean) => void;
    item?: ICustomSegment;
    hasSegmentShareClaim?: boolean;
    isMyDomain?: boolean;
    isDisabled?: boolean;
    customRenderData?: React.ReactNode;
}

export const ListItemSegment: React.FC<IListItemSegment> = ({
    onClick,
    isActive,
    className,
    img,
    domain,
    name,
    itemSignType,
    onActionClick,
    item,
    hasSegmentShareClaim = false,
    isMyDomain = false,
    isDisabled = false,
    customRenderData,
}) => {
    const onShareClick = () => {
        // @ts-ignore FIXME: strict migration - 'onActionClick' and 'item' possibly undefined — onShareClick is only wired as a handler when the caller provides both
        onActionClick(item, true);
    };

    const isSegment = !!name;

    return (
        <>
            {isSegment ? (
                <SegmentListItemWrapper
                    onClick={onClick}
                    isActive={isActive}
                    className={className}
                    withSegmentSign={itemSignType === SEGMENT_TYPES.SEGMENT}
                    img={img}
                    segmentName={name}
                    domainName={domain}
                    isDisabled={isDisabled}
                    customRenderData={customRenderData}
                />
            ) : (
                <DomainListItemWrapper
                    onClick={onClick}
                    isActive={isActive}
                    className={className}
                    withSign={itemSignType}
                    img={img}
                    actionIcon={isMyDomain && hasSegmentShareClaim ? SHARE_ICON : undefined}
                    onActionClick={isMyDomain && hasSegmentShareClaim ? onShareClick : undefined}
                    text={domain}
                    isDisabled={isDisabled}
                />
            )}
        </>
    );
};
